import { getCertificateCreateFieldSelector } from "raft/CertificateForm";
import { getUnitCreateFieldSelector } from "raft/UnitForm";
import { useCallback, useEffect } from "react";
import { SetterOrUpdater, useRecoilCallback } from "recoil";
import useGetItemtext from "../NormBridgeList/useGetItemtext";

const useGetLables = () => {
  const getItemtext = useGetItemtext();
  const getLables = useCallback(
    (normBridgeIds: string[]): string => {
      const normNumbers = normBridgeIds
        .map((id) => {
          const [certificateNormName] = getItemtext(id).split(":");
          return certificateNormName.replace("VDE-AR-N 41", "").trim();
        })
        .join(",");
      return normNumbers;
    },
    [getItemtext]
  );
  return getLables ?? "";
};

export const useManageNormlist = (
  useBridgeArrayState: () => [string[], SetterOrUpdater<string[]>]
): [string[], SetterOrUpdater<string[]>] => {
  const setNormLists = useSetNormLists();
  const getLables = useGetLables();
  const [normBridgeIds, setNormBridgeIds] = useBridgeArrayState();
  useEffect(() => {
    setNormLists(getLables(normBridgeIds));
  }, [normBridgeIds, getLables, setNormLists]);
  return [normBridgeIds, setNormBridgeIds];
};

const useSetNormLists = () => {
  return useRecoilCallback(
    ({ set }) =>
      (labels: string) => {
        // Set for both form versions to ensure compatibility
        try {
          const __normListAtomMatrix = getCertificateCreateFieldSelector({ formVersion: "matrixCertificateCreate" })(
            "__normList"
          );
          const __normListAtomUnitsMatrix = getUnitCreateFieldSelector({ formVersion: "matrixUnitCreate" })(
            "__normList"
          );
          set(__normListAtomMatrix, labels);
          set(__normListAtomUnitsMatrix, labels);
        } catch (e) {
          // Ignore if matrix form doesn't exist
        }

        try {
          const __normListAtomActive = getCertificateCreateFieldSelector({ formVersion: "active" })("__normList");
          const __normListAtomUnitsActive = getUnitCreateFieldSelector({ formVersion: "active" })("__normList");
          set(__normListAtomActive, labels);
          set(__normListAtomUnitsActive, labels);
        } catch (e) {
          // Ignore if active form doesn't exist
        }
      },
    []
  );
};
